export default __webpack_public_path__ + "static/media/edit_pencil.182cd554.svg";